import React from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import SuperadminSidebar from "./SuperadminSidebar";

const SideNav = ({ user_status }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      {user_status === "admin" ? (
        <SuperadminSidebar isOpen={isOpen} />
      ) : (
        <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
     <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />

    </>
  );
};

export default SideNav;
